/*
	FrontLaucher main js file 
*/

import slick from 'slick-carousel';
import '!style!css!slick-carousel/slick/slick.css';
import 'foundation-sites';
require('!style!css!fancybox/dist/css/jquery.fancybox.css');
const fancybox = require('fancybox')($);
const tinyNav = require('tinynav');

const App = {
	isTouch: function () {
        let isTouch = "ontouchstart" in window || navigator.msMaxTouchPoints;
        return isTouch;
    },
	mainSlider:function () {
		const $el = $('.slider');
		const $nav = $('.slider-nav ul .slickNav');
		const options = {
			arrows:false,
			adaptiveHeight:true,
			fade:true
		};
		$el.slick(options);

		$nav.click(function (e) {
			let index = $(this).parent().index();
			$el.slick('slickGoTo',index);
		});
		this.sliderPagination($el,$('#slider-dots'))
	},
	sliderPagination: function(slider,pagination) {
		var $navPagination = pagination;
		var $slider = slider;
		var info = $slider.slick('getSlick');

		for (var i = 1; i <= info.slideCount; i++) {
			$('<span class="dot">'+i+'</a>').appendTo($navPagination);
		};
		var $dot = $navPagination.find('.dot');
		$dot.first().addClass('active');
		$dot.click(function(e){
			e.preventDefault(); // if you used a with href instead of span
			var number = $(this).html();
			$slider.slick('slickGoTo',--number);
		});
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			$dot.removeClass('active')
			$dot.eq(nextSlide).addClass('active')
		});
	},
	startFastClick: function() {
		if ('touchAction' in document.body.style) {
		    document.body.style.touchAction = 'manipulation';
		} else {
		    require.ensure(['fastclick'], (require) => {
		        const FastClick = require('fastclick');

		        window.addEventListener('load', () => {
		            FastClick.attach(document.body);
		        });
		    }, 'fastclick');
		}
	},
	initialize: function(){
	    $('.fancybox').fancybox();
	    $(document).foundation();
	},
	scrollTo: function(element,scrollTo){
		var $el = $(element);
		$el.click(function(event){
			$('html,body').animate({
				scrollTop: $(scrollTo).offset().top
			}, 1000);
			event.preventDefault();
		});
	},
	initMap: function(){
		// vanillaJS
		const findMap = document.getElementsByClassName('gmap');
		const scriptUrl = "http://maps.google.com/maps/api/js?key=AIzaSyAfpg5or3YW6mMeYiiczmkLhxbl0llqxIY";

		const loadMap = function(){
			for (let i = findMap.length - 1; i >= 0; i--) {
				let myMap = findMap[i];

				let center = new google.maps.LatLng(myMap.getAttribute('data-lat'), myMap.getAttribute('data-lon'));
				let zoom  = parseInt(myMap.getAttribute('data-zoom')) || 13;

				let map = new google.maps.Map(myMap, {
					zoom,
					center,
					disableDefaultUI: false,
					draggable: !App.isTouch(),
					scrollwheel: false
				});

				let markerOptions = {
					map: map,
				//	icon: 'assets/img/point.png',
					position: point
				};

				let marker = new google.maps.Marker(markerOptions);
			};
		};
		if (findMap.length) {
			const s = document.createElement( 'script' );
			s.setAttribute( 'src', scriptUrl );
			s.onload=loadMap;
			document.body.appendChild( s );
		}
	},
	responsiveNav: function () {
		$("header nav.main ul").tinyNav({
			header: 'Menu',
			addHashHistory:true
		});
	},
	autoScrool:function(){
		var $cell = $('.page');
		if($cell.length) {
		$('html,body').animate({
			scrollTop: $cell.offset().top - $('.breadcrumb').outerHeight()
		},700)
		}
	},
	homepageActive: function(){
        console.log();
		if(window.location.pathname == '/' || window.location.pathname == '/e-projekty/2016/czesci-samochodowe/carox.pl/'){
			$('#nav-main ul li:first-child a').addClass('active');
		}

	},
	brandsSlider: function () {
		$('.brands-list').slick({
			slidesToShow: 6,
			slidesToScroll: 1,
			autoplay: true,
			infinite: true,
			arrows: false,
			variableWidth:true,
			autoplaySpeed: 2000,

			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
						slidesToScroll: 1,
						variableWidth:false,
					}
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 1,
						variableWidth:false,
					}
				},
                {
                    breakpoint: 700,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        variableWidth:false,
                    }
                },
                {
                    breakpoint: 475,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth:false,
                    }
                },
			]
		});
	},
	init: function(){
		document.addEventListener('DOMContentLoaded', () => {
			this.startFastClick();  
			this.initialize();
			this.scrollTo('#toTop','header');
			this.mainSlider();
			this.responsiveNav();
			this.homepageActive();
			this.brandsSlider();
		}, false);

		window.onload = () => {
			this.autoScrool();
		};

		window.onresize = () => {

		};
	}
}

App.init();


/** WEBPACK FOOTER **
 ** ./app.js
 **/